import { createContext } from 'react'

export const UtilsContext = createContext()
